var React = require('react');

function CheckmarkCircleInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.0036 8.50546C14.0036 5.19224 11.3155 2.50415 8.00228 2.50415C4.68906 2.50415 2.00098 5.19224 2.00098 8.50546C2.00098 11.8187 4.68906 14.5068 8.00228 14.5068C11.3155 14.5068 14.0036 11.8187 14.0036 8.50546Z","stroke":"#232427","strokeWidth":"1.00189","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M11.0041 6.00464L6.8026 11.0064L5.00195 9.00572","stroke":"#232427","strokeWidth":"1.00189","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckmarkCircleInline.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = CheckmarkCircleInline;

CheckmarkCircleInline.default = CheckmarkCircleInline;
